export interface OCClaimPagedResponse {
  data?: unknown[];
  nextPage?: number;
  totalRows?: number;
}

/**
 * Computes the next page index for OC claim infinite queries.
 * Stops when the API returns no rows or when pageIndex exceeds totalPages.
 */
export const getOCClaimNextPage = (
  pageIndex: number,
  pageSize: number,
  totalRows: number,
  pageDataLength: number,
): number | undefined => {
  if (pageDataLength === 0) {
    return undefined;
  }

  const totalPages = Math.ceil(Number(totalRows ?? 0) / pageSize);
  const hasMoreByIndex = Number(pageIndex) < totalPages;

  return hasMoreByIndex ? Number(pageIndex) + 1 : undefined;
};

/**
 * TanStack infinite-query guard: stop when all rows are loaded even if lastPage.nextPage is set.
 */
export const getOCClaimInfiniteNextPageParam = (
  lastPage: OCClaimPagedResponse | undefined,
  allPages: OCClaimPagedResponse[],
): number | undefined => {
  if (!lastPage) {
    return undefined;
  }

  const loadedCount = allPages.flatMap((page) => page?.data ?? []).length;
  const totalRows = Number(lastPage.totalRows ?? 0);

  if (totalRows > 0 && loadedCount >= totalRows) {
    return undefined;
  }

  return lastPage.nextPage;
};
